// Shared reflow utility strings for the 4/e lesson overview (PLAT-17224).
// Applied when the `accessibilityReflow` LD flag is on.

// Card with a fixed height becomes min-height so content can grow with text-zoom.
export const CARD_HEIGHT_REFLOW = 'tw-min-h-[6rem]';
